import { render, staticRenderFns } from "./activitiesVideo3.vue?vue&type=template&id=2a11fe11&scoped=true"
import script from "./activitiesVideo3.vue?vue&type=script&lang=js"
export * from "./activitiesVideo3.vue?vue&type=script&lang=js"
import style0 from "./activitiesVideo3.vue?vue&type=style&index=0&id=2a11fe11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a11fe11",
  null
  
)

export default component.exports